import { SeparatorWeb } from "./web";
import { SeparatorBlockProps } from "./types";

export function SeparatorWebEditor(props: SeparatorBlockProps) {
  return <SeparatorWeb {...props} />;
}
